import ContainersPerMonth from '../Widget.ContainersPerMonth/Widget.ContainersPerMonth'
import TEUByMonth from '../Widget.TEUByMonth/Widget.TEUByMonth'
import MonthlyWeightShipped from '../Widget.MonthlyWeightShipped/Widget.MonthlyWeightShipped'
import ShipmentsPerDay from '../Widget.ShipmentsPerDay/Widget.ShipmentsPerDay'
import TopInTransitLanes from '../Widget.TopInTransitLanes/Widget.TopInTransitLanes';
import OnTimeArrival from "../Widget.OnTimeArrival/Widget.OnTimeArrival";
import ShipmentCountByDestinationRegion from '../Widget.ShipmentCountByDestinationRegion/Widget.ShipmentCountByDestinationRegion';
import ModeOfTransportationBreakdownByMonth from '../Widget.ModeOfTransportationBreakdownByMonth/Widget.ModeOfTransportationBreakdownByMonth';
import OnTimeDeparture from "../Widget.OnTimeDeparture/Widget.OnTimeDeparture";

const Widgets = {
    ContainersPerMonth,
    TEUByMonth,
    MonthlyWeightShipped,
    ShipmentsPerDay,
    TopInTransitLanes,
    ShipmentCountByDestinationRegion,
    OnTimeArrival,
    ModeOfTransportationBreakdownByMonth,
    OnTimeDeparture
}

export default Widgets;